import { render, staticRenderFns } from "./TerraIndigenaStatusDelimitado.vue?vue&type=template&id=56c3b1db&lang=pug"
import script from "./TerraIndigenaStatusDelimitado.vue?vue&type=script&lang=js"
export * from "./TerraIndigenaStatusDelimitado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports